import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { HeadsetBillingRecord, PackageBillingRecord } from 'src/models';
import { RootState } from 'src/store';
import { companyBillingSelectors } from 'src/store/reducers/companyBilling';

export const useCompanyBillingState = (): RootState['companyBilling'] => {
  const state = useSelector<RootState, RootState['companyBilling']>(
    (state) => state.companyBilling,
  );

  useDebugValue(state);

  return state;
};

export const useHeadsetsBillingByCompanyId = (
  companyId: string,
): HeadsetBillingRecord[] => {
  const state = useSelector<RootState, RootState['companyBilling']>(
    (state) => state.companyBilling,
  );

  const record = companyBillingSelectors.selectById(state, companyId);

  useDebugValue(record);

  return record?.headsets || [];
};

export const useHeadsetsSucceededBillingByCompanyId = (
  companyId: string,
): HeadsetBillingRecord[] => {
  const state = useSelector<RootState, RootState['companyBilling']>(
    (state) => state.companyBilling,
  );

  const record = companyBillingSelectors.selectById(state, companyId);

  useDebugValue(record);

  const records = record?.headsets || [];
  return records.filter(
    (r) =>
      r.qrCodeSucceeded ||
      r.deskSucceeded ||
      r.paymentSystemSucceeded ||
      r.vipAccessSucceeded ||
      r.roomBillSucceeded,
  );
};

export const usePackagesBillingByCompanyId = (
  companyId: string,
): PackageBillingRecord[] => {
  const state = useSelector<RootState, RootState['companyBilling']>(
    (state) => state.companyBilling,
  );

  const record = companyBillingSelectors.selectById(state, companyId);

  useDebugValue(record);

  return record?.packages || [];
};
